var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.member)?_c('MemberAuthorizationManager',{attrs:{"area":_vm.area,"member":_vm.member,"type":"detail"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }